import { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function ShareButton({ text, path, testId = "share-btn", compact = false }) {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}${path}`;
  const wa = `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`;

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success("Lien copié"); setTimeout(() => setCopied(false), 1500); }
    catch { toast.error("Copie impossible"); }
  };

  return (
    <div className="flex items-center gap-1.5" data-testid={testId}>
      <a data-testid={`${testId}-whatsapp`} href={wa} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
        className={`sc-btn text-xs bg-[#25D366] text-white hover:bg-[#1ebe5b] border-0 ${compact ? "px-2.5 py-1.5" : ""}`}>
        <Share2 className="w-3.5 h-3.5" /> WhatsApp
      </a>
      <button data-testid={`${testId}-copy`} onClick={(e) => { e.stopPropagation(); copy(); }} className={`sc-btn sc-btn-outline text-xs ${compact ? "px-2.5 py-1.5" : ""}`} aria-label="Copier le lien">
        {copied ? <Check className="w-3.5 h-3.5 text-emerald-600" /> : <Copy className="w-3.5 h-3.5" />}
      </button>
    </div>
  );
}
